<template>
  <div class="container guardianship_container">
    <!-- 家长监护 -->
    <div class="nav-box">
      <el-tabs v-model="activeName2" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, key) in tabArray"
          :key="key"
          :label="item.title"
          :name="item.title"
        >
          <div v-if="item.title == '工程体系'"><application /></div>
          <div v-else-if="item.title == '服务申请'"><system /></div>
          <div v-else><problem /></div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import system from "./components/system";
import application from "./components/application";
import problem from "./components/problem";
export default {
  components: { system, application, problem },
  data() {
    //这里存放数据
    return {
      activeName2: "工程体系",
      tabArray: [
        { id: 0, title: "工程体系", content: "工程体系" },
        { id: 1, title: "服务申请", content: "服务申请" },
        { id: 2, title: "常见问题", content: "常见问题" },
      ],
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: { handleClick() {} },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
